import { defineStore } from 'pinia';
import { ref, watch } from 'vue';

export const useThemeStore = defineStore('theme', () => {
    // Initialize from localStorage or system preference
    const savedTheme = localStorage.getItem('theme');
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    const currentTheme = ref(savedTheme || (prefersDark ? 'dark' : 'light'));

    const toggleTheme = () => {
        currentTheme.value = currentTheme.value === 'dark' ? 'light' : 'dark';
    };

    const setTheme = (theme) => {
        currentTheme.value = theme;
    };

    // Apply theme to HTML element
    watch(currentTheme, (newTheme) => {
        document.documentElement.setAttribute('data-theme', newTheme);
        localStorage.setItem('theme', newTheme);
    }, { immediate: true });

    return {
        currentTheme,
        toggleTheme,
        setTheme
    };
});
